module.exports = __webpack_public_path__ + "static/media/About_Infographic.0ec231a1.svg";